import { ResumableExtractionBanner } from '@bb/onboarding-core';
import { useAuth } from '@bb/session-manager';
import { PLAYBOOK_BUILDER_PERMISSION, UPLOAD_CONTRACT_PERMISSION } from '../../groups.config';
import { isWebFtueEnabled } from './webFtueFlag';

/**
 * Renders the shared resumable-extraction banner for returning users. `WebFtue`
 * only mounts `OnboardingPage` for first-time users, so a returning user with
 * an in-flight or just-finished extraction had no surface that could ever show
 * it -- this is that surface, gated by the same flag + permissions as WebFtue
 * since resuming needs the same capabilities to complete.
 *
 * Returns null (renders nothing) when there's nothing to resume.
 */
export function WebResumableExtractionBanner() {
  const { hasAllPermissions } = useAuth();

  if (!isWebFtueEnabled()) {
    return null;
  }
  if (!hasAllPermissions([PLAYBOOK_BUILDER_PERMISSION, UPLOAD_CONTRACT_PERMISSION])) {
    return null;
  }

  return <ResumableExtractionBanner />;
}
